<template>
  <div class="" v-if="companyData != null">
    <div class="">
      <!-- <div class="registration-head text-center"> -->
        <div
        class="registration-head text-center"
        :style="styleHeader"
        :class="[companyData.logo_alignment ? 'v-logo-style' : '']"
      >
        <!-- <h1>{{ companyData.companyName }} キャリア登録</h1> -->

        <div
          class="center-logo vertical-logo"
          v-if="companyData.logo_alignment"
        >
          <img
            v-if="companyData.companyLogo !== null"
            :src="companyData.companyLogo"
            alt="logo"
            class="img-fluid"
          />
          <i class="fas fa-building" v-else></i>
        </div>
        <div class="center-logo horizontal-logo" v-else>
          <img
            v-if="companyData.companyLogo !== null"
            :src="companyData.companyLogo"
            alt="logo"
            class="img-fluid"
          />
          <i class="fas fa-building" v-else></i>
        </div>
      </div>
      <!-- </div> -->
       <div class="sml-container" style="padding-top:100px">
        <div class="fast-group-sec">
            <div class="fast-group">
              <h1>{{ companyData.companyName }}</h1>
              <p>キャリア登録ページ</p>
            </div>
            <div class="fast-box">
              <p>
                株式会社Bloom提供の「Bloomキャリア登録」を利用しています。
              </p>
            </div>
          </div>
       </div>
      <div class="sml-container">
        <div class='container content-head'>
              <div v-html="companyData.companyDescription" style="font-size: 16px;"></div>
              <!-- <p>株式会社Bloom提供の「Bloomキャリア登録」を利用しています。</p> -->
          </div>
      </div>
      <div class="sml-container">
        <div class="career-img" style="border-bottom: 1px solid #C4C4C4">
          <!-- <img src="./../assets/images/career-img.png" alt="logo" class="img-fluid"/> -->
          <img
            src="./../assets/images/career-img-svg-2.svg"
            alt="logo"
            class="img-fluid"
            style="height:100%;width:100%"
          />
          <p class="text-center mobile-break" style="font-size: 16px;">
            適したポジションがある際に連絡が届きます。<br class="mobile-only">
            ご希望の方は以下より情報をご登録ください。
          </p>
        </div>
      </div>
      <div class="sml-container">
        <div class="rgst-sec">
          <div class="rgst-dtl-sec">
            <!-- registration form component -->
            <BRegistration :endpointKey="'ServerValidation'" @redirectToPreviewPage="redirectToPreview"/>
          </div>
        </div>
        <!-- ends rgst-sec -->
      </div>
    </div>
    <!-- ends main-area -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BRegistration from "./BRegistration.vue";
import TitleContainer from "./TitleContainer.vue";
export default {
  name: "Registration",
  components: { BRegistration, TitleContainer },
  data() {
    return {
      check: true
    }
  },
  computed: {
    ...mapGetters({companyData: "getCompanyData"}),
    styleBorder() {
      return this.companyData.brand_primary_color
        ? { border: `16px solid ${this.companyData.brand_primary_color}` }
        : { border: "#000000" };
    },
    styleHeader() {
      return this.companyData.brand_primary_color
        ? { background: this.companyData.brand_primary_color }
        : { background: '#000000' };
    },
    styleButton() {
      return this.companyData.brand_secondary_color
        ? {
            background: this.companyData.brand_secondary_color,
            "border-color": this.companyData.brand_secondary_color,
          }
        : {
            background: "#000000",
            "border-color": "#000000",
          };
    },
  },
  methods: {
    ...mapActions({
      setData: "setData",
      checkCompany: "checkCompany",
    }),
    redirectToPreview(){
      this.$router.push({
        name: "preview",
        params: { slug: this.$route.params.slug },
      });
    },
    scrollToTop() {
      const element = document.getElementsByClassName("main-wrapper")[0];
      if (element) {
        element.scrollIntoView();
        // console.log(parent.offsetTop - (parent.offsetHeight * 2));
        // console.log(parent.offsetTop);
        // console.log(document.getElementsByClassName('form-detail')[0]);
        // document.getElementsByClassName('form-detail')[0].scrollTop =
        // parent.offsetTop - (parent.offsetHeight * 2);
      }
    },
  },
  async mounted() {
    this.scrollToTop();
    const check = await this.checkCompany(this.$route.params.slug);
    if (!check) this.$router.push({ name: "Maintenance" });
  },
  metaInfo() {
    const companyData = this.companyData;
    return {
      // titleTemplate: companyName
      title: companyData
        ? `${companyData.companyName} | Bloomキャリア登録`
        : 'Bloomキャリア登録',
      meta: [
        {
          name: 'description',
          content: companyData
            ? `${this.companyData.companyName} など社会を変える影響力の高い企業にて、「自分の経験が活かせるポジションが知りたい」「すぐの応募ではなく、まずは情報収集したい」といった方はぜひご登録ください。`
            : 'など社会を変える影響力の高い企業にて、「自分の経験が活かせるポジションが知りたい」「すぐの応募ではな11く、まずは情報収集したい」といった方はぜひご登録ください。',
        },
        {
          property: 'og:title',
          content: companyData
            ? `${companyData.companyName} | Bloomキャリア登録`
            : 'Bloomキャリア登録',
          template: companyData
            ? `${companyData.companyName} | Bloomキャリア登録`
            : 'Bloomキャリア登録',
        },
        { property: 'og:site_name', content: 'Bloomキャリア登録' },
        { property: 'og:type', content: 'website' },
      ],
    };
  },
};
</script>

<style scoped>
.mobile-break .mobile-only {
  display: none;
}
.bg-gray {
    background: #EDEDED; 
}

.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#currently_enrolled {
  height: 15px;
  width: 15px;
}
.btn-cstm.btn-cv-submit {
  width: 47%;
}

.btn-cstm.btn-cv-delete {
  background-color: #787878;
  font-weight: 500;
  width: 49%;
}

textarea::placeholder {
  font-size: 16px;
}

textarea {
  display: flex;
  align-items: center;
}

.font-15 {
  font-size: 15px;
}

.flex-basis-100 {
  flex-basis: 100%;
}

@media (max-width: 767px) {
  .mobile-break .mobile-only {
    display: inline;
  }

  .mobile-break {
    font-size: 16px;
  }

  .btn-cstm.btn-cv-submit {
    width: 100%;
  }

  .btn-cstm.btn-cv-delete {
    width: 100%;
    margin: 0px !important;
  }
}

@media only screen and (max-width: 992px) {
  .enrolled-date {
    flex-wrap: wrap;
  }
  .enrolled-date span {
    flex-basis: 100%;
    justify-content: center;
  }
}

.enrolled-date select {
  margin-right: 5px;
}

.enrolled-date span {
  margin-right: 20px;
  display: inline-flex;
  align-items: center;
  font-size: 25px;
  font-weight: 500;
}

.enrolled-date label {
  margin-right: 20px;
  display: inline-flex;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  color: #494949;
}

.disabled {
  background-image: none !important;
}

.mw-370 {
  max-width: 370px;
}

.is-valid {
  background-image: none;
}

.is-invalid {
  background-image: none;
}
.v-center {
  display: flex;
  align-items: center;
}
.justify-content-evenly {
  justify-content: space-evenly;
}
</style>
